import api from './api';

export interface Topic {
  id: string;
  wedding_id: string;
  name: string;
  emoji: string | null;
  status: 'not_started' | 'in_progress' | 'covered';
  deadline: string | null;
  assigned_planner_id: string | null;
  notes: string | null;
  created_at: string;
  updated_at: string;
}

export interface TopicDetail {
  topic: Topic;
  task_count: number;
  completed_task_count: number;
}

export interface TopicFormData {
  name: string;
  emoji?: string | null;
  status?: string;
  deadline?: string | null;
  assigned_planner_id?: string | null;
  notes?: string | null;
}

export const getTopics = (params?: Record<string, string>) =>
  api.get<Topic[]>('/topics', { params });
export const getTopic = (id: string) => api.get<TopicDetail>(`/topics/${id}`);
export const createTopic = (data: TopicFormData) => api.post<Topic>('/topics', data);
export const updateTopic = (id: string, data: Partial<TopicFormData>) =>
  api.put<Topic>(`/topics/${id}`, data);
export const deleteTopic = (id: string, cascade: boolean = false) =>
  api.delete(`/topics/${id}`, { params: { cascade } });
